import React, { FunctionComponent, ReactNode } from 'react';
import { Link } from 'gatsby';
import { formatLink } from '../../utils/formatLink';
import { PagePath } from '../../types/common';

type PagePathParams = Omit<PagePath, '_id' | '_key'>;

type InternalLinkProps = {
  reference: PagePathParams;
  children: ReactNode;
  className?: string | undefined;
  id?: string | undefined;
}

const InternalLink: FunctionComponent<InternalLinkProps> = ({ reference, children, className, id }) => {
  const url = formatLink(reference);

  return (
    <Link
      to={url}
      className={className ? className : ""}
      id={id}
    >
      {children}
    </Link>
  );
}

export default InternalLink;
